import * as actions from './actions';
import * as constants from './constants';
import reducer from './reducer';

export { actions, constants, reducer };



// WEBPACK FOOTER //
// ./modules/Modal/redux/index.js